import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {black, imac13inMax, lightBlue, marketingMobileCuttoff} from "@css/constants";
import {fontSize} from "@css/styles";
import {FontNormal} from "@css/fonts";

export const LearnMoreSectionContainer = styled('div')(css`
  display: flex;
  flex-direction: column;
  padding-top: 70px;

  @media(max-width: ${marketingMobileCuttoff}) {
    flex-direction: column;
    padding: 40px 0;
  }
`)

export const LearnMoreSectionRow = styled('ul')(css`
  display: flex;
  flex-direction: row;
  margin: 0 16px 40px;
  flex-flow: wrap;
  align-self: center;
  place-content: center;
  list-style: none;

  @media(max-width: ${marketingMobileCuttoff}) {
    flex-direction: column;
    display: block;
    margin-bottom: 0;
  }
`)

export const LearnMoreSectionHeader = styled('div')(css`
  @media(max-width: ${marketingMobileCuttoff}) {
    margin-bottom: 20px;
    border-left: 10px solid ${lightBlue};
    padding-left: 15px;
  }
`)

export const LearnMoreSectionHeaderTitle = styled('h3')(css`
  font-size: 32px;
  ${FontNormal(600)};
  color: ${black};
  align-self: center;
  text-align: center;
  margin-bottom: 40px;

  @media(max-width: ${marketingMobileCuttoff}) {
    text-align: initial;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-right: 20px;
    margin-bottom: 0;
  }
`)
export const LearnModeSectionEmptyRow = styled.li`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
